import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Ajout du Link
import { login } from "../auth";
import '../../src/halloween.css';
import LoadingOverlay from '../components/LoadingOverlay';

const Login: React.FC = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async () => {
        setError('');
        if (!email || !password) {
            setError('Veuillez remplir tous les champs.');
            return;
        }
        if (!/\S+@\S+\.\S+/.test(email)) {
            setError('Adresse email invalide.');
            return;
        }

        try {
            setError('');
            setIsLoading(true); 
            const response = await login(email, password);

            if (response.data.accessToken) {
                sessionStorage.setItem('tokenAdminUI', response.data.accessToken);
                sessionStorage.setItem('refreshTokenAdminUI', response.data.refreshToken);
                navigate('/');
            } else {
                setError('Email ou mot de passe incorrect.');
            }
        } catch (error) {
            setError('Erreur lors de la connexion. Veuillez réessayer.');
        } finally {
            setIsLoading(false); 
        }
    };

    const handleKeyPress = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            handleLogin();
        }
    };

    return (

        <>
            <LoadingOverlay isOpen={isLoading} />

        <div className="flex flex-col lg:flex-row items-center justify-center min-h-screen bg-gradient-to-br from-green-50 to-emerald-100 p-4">
        {/* Bloc de gauche - Formulaire de connexion */}
        <div className="w-full lg:w-2/5 flex justify-center items-center lg:p-8 order-2 lg:order-1">
            <div className="w-full max-w-lg p-4 sm:p-6 md:p-8 bg-white/80 backdrop-blur-sm rounded-xl shadow-xl relative z-10">
                <div className="text-center mb-6 sm:mb-8">
                    <img 
                        src={`${process.env.PUBLIC_URL}/logo_admin_wattless-removebg-preview.png`}
                        alt="Logo" 
                        className="mx-auto w-full max-w-[200px] h-auto mb-3 sm:mb-4"
                    />
                    <h2 className="text-xl sm:text-2xl font-semibold text-emerald-800">
                        Connexion à votre espace éco-responsable
                    </h2>
                    <p className="text-xs sm:text-sm text-emerald-600 mt-2">
                        Ensemble, économisons l'énergie
                    </p>
                </div>
                
                {error && (
                    <div className="text-red-600 mb-4 text-center text-sm sm:text-base font-medium bg-red-50 p-2 sm:p-3 rounded-lg">
                        {error}
                    </div>
                )}

                <div className="space-y-4 sm:space-y-6">
                    <div>
                        <label className="block text-emerald-700 text-sm sm:text-base font-medium mb-1 sm:mb-2">
                            Email
                        </label>
                        <div className="relative">
                            <input
                                type="email"
                                className="w-full p-2 sm:p-3 pl-9 sm:pl-10 text-sm sm:text-base border border-emerald-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent bg-white/50"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Entrez votre email"
                            />
                            <svg className="w-4 h-4 sm:w-5 sm:h-5 text-emerald-500 absolute left-2.5 sm:left-3 top-2.5 sm:top-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
                            </svg>
                        </div>
                    </div>

                    <div>
                        <label className="block text-emerald-700 text-sm sm:text-base font-medium mb-1 sm:mb-2">
                            Mot de passe
                        </label>
                        <div className="relative">
                            <input
                                type="password"
                                className="w-full p-2 sm:p-3 pl-9 sm:pl-10 text-sm sm:text-base border border-emerald-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent bg-white/50"
                                value={password}
                                onKeyDown={handleKeyPress}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Entrez votre mot de passe"
                            />
                            <svg className="w-4 h-4 sm:w-5 sm:h-5 text-emerald-500 absolute left-2.5 sm:left-3 top-2.5 sm:top-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                            </svg>
                        </div>
                    </div>

                    <button
                        onClick={handleLogin}
                        className="w-full py-2 sm:py-3 bg-emerald-600 text-white rounded-lg font-medium text-sm sm:text-lg hover:bg-emerald-700 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-opacity-50"
                    >
                        Se connecter
                    </button>
                    {/*
                    <div className="text-center text-sm sm:text-base">
                        <Link to="/forgot-password" className="text-emerald-600 hover:text-emerald-700 hover:underline transition-colors duration-300">
                            Mot de passe oublié ?
                        </Link>
                    </div>
                    */}
                </div>
            </div>
        </div>

        {/* Bloc de droite - Illustration */}
        <div className="w-full lg:w-1/2 flex justify-center items-center p-4 sm:p-6 lg:p-8 order-1 lg:order-2 mb-6 lg:mb-0">
            <div className="max-w-md lg:max-w-lg">
                <div className="relative">
                    <div className="absolute inset-0 bg-emerald-100 rounded-full filter blur-3xl opacity-70"></div>
                    <div className="relative z-10 text-center space-y-3 sm:space-y-4">
                        <div className="flex justify-center">
                            <svg className="w-32 h-32 sm:w-40 sm:h-40 md:w-48 md:h-48 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
                            </svg>
                        </div>
                        <h3 className="text-xl sm:text-2xl font-bold text-emerald-800">Gérez votre consommation</h3>
                        <p className="text-sm sm:text-base text-emerald-600 px-4">Suivez et optimisez votre consommation d'énergie en temps réel</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </>
    );
};

export default Login;
